// How a UK payslip was paid. The bank methods name the account on the slip;
// cash and cheque do not, and a cheque can carry its number.

export const UK_PAYMENT_METHODS = [
  { code: "bacs", label: "BACS", menu: "BACS", badge: "BACS", toBank: true },
  { code: "faster_payments", label: "Faster Payments", menu: "Faster Payments", badge: "FPS", toBank: true },
  { code: "chaps", label: "CHAPS", menu: "CHAPS (Same-Day High Value)", badge: "CHAPS", toBank: true },
  { code: "bank_transfer", label: "Bank Transfer", menu: "Bank Transfer", badge: "BANK", toBank: true },
  { code: "standing_order", label: "Standing Order", menu: "Standing Order", badge: "S/O", toBank: true },
  { code: "cash", label: "Cash", menu: "Cash", badge: "CASH", toBank: false },
  { code: "cheque", label: "Cheque", menu: "Cheque", badge: "CHEQUE", toBank: false },
];

// The method's wording for a template: how the banner, the "paid by" lines
// and the payment box read, with the account only where money went to one
export function describePayment(code, { bankLast4 = "", chequeNo = "", paidOn = "" } = {}) {
  const m = UK_PAYMENT_METHODS.find((x) => x.code === code) || UK_PAYMENT_METHODS[0];
  const isCash = m.code === "cash";
  const isCheque = m.code === "cheque";
  const upper = m.label.toUpperCase();
  const paidBy = isCash ? "Paid in cash" : `Paid by ${m.label}`;
  const chequeText = isCheque ? (chequeNo ? `Cheque No ${chequeNo}` : "Cheque") : "";
  return {
    ...m,
    isCash,
    isCheque,
    // "PAID BY BACS" / "PAID IN CASH", the banner's phrase
    banner: isCash ? "PAID IN CASH" : `PAID BY ${upper}`,
    // "Paid by BACS" / "Paid in cash" / "Paid by Cheque"
    paidBy,
    // the payment box's first line: the account, the cheque, or cash
    accountLine: m.toBank ? `Account ****${bankLast4 || "0000"}` : (isCheque ? chequeText : "Paid in cash"),
    // one sentence for a net pay band
    sentence: m.toBank
      ? `Paid by ${m.label} to account ending ${bankLast4 || "0000"}${paidOn ? ` on ${paidOn}` : ""}`
      : isCheque
        ? `Paid by cheque${chequeNo ? ` No ${chequeNo}` : ""}${paidOn ? ` on ${paidOn}` : ""}`
        : `Paid in cash${paidOn ? ` on ${paidOn}` : ""}`,
  };
}
